import { LitElement, html } from '@hh/global.js'

class HHNav extends LitElement {
  constructor() {
    super()
    this.firstLevelWithNav = this.querySelectorAll('.header__desktop-nav > li.header__inline-has-dropdown > .sub-nav')
    this.firstLevelWithNavIcon = this.querySelectorAll('.header__desktop-nav > li.header__inline-has-dropdown .header__menu-item__icon')

    this.firstLevelWithNavIcon.forEach((element, index) => {
      element.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          this.toggleNav(e)
        }
      })
    })
  }

  toggleNav(e) {
    const dropdownItem = e.target.closest('.header__inline-has-dropdown');
    const subnav = dropdownItem.querySelector('.sub-nav');
    const isExpanded = subnav.style.display !== 'none' && subnav.style.display !== '';

    this.closeAllSubMenus()
    subnav.style.display = isExpanded ? 'none' : 'block';
    dropdownItem.querySelector('span[aria-expanded]').setAttribute('aria-expanded', !isExpanded);
  }

  closeAllSubMenus() {
    this.firstLevelWithNav.forEach((element) => {
      element.style.display = 'none'
    })
  }

  render() {
    return html`
      <slot></slot>
    `;
  }
}

customElements.define('hh-nav', HHNav);